import { useBrowseEnrichmentApi } from '@aibees/elephant/api/enrichment/use-browse-enrichment-api';
import {
  CreateActionBulkDialog,
  CreateActionBulkDialogData,
} from '@aibees/elephant/components/create-action-bulk-dialog';
import { notificationIconMap } from '@aibees/elephant/utils';
import { useBoolean, useNotify } from '@aibees/shared/hooks';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { random } from 'lodash-es';
import { memo } from 'react';
import { useUpdateEnrichmentApi } from '../../../../api/enrichment/use-update-enrichment-api';
import type { EditEnrichmentDialogProps as Props } from './types';

export const EditEnrichmentDialog = memo(
  ({ className, item, state }: Props) => {
    const notify = useNotify();
    const api = useUpdateEnrichmentApi(item.id);

    const loading = useBoolean();

    const handleClose = () => {
      state.onFalse();
    };

    const handleSubmit = (data: CreateActionBulkDialogData) => {
      loading.onTrue();
      api
        .mutateAsync({ name: data.name })
        .then(() => {
          loading.onToggle();
          handleClose();
          notify.complete(
            'Enrichment Name Updated',
            'Name changed successfully.',
            random(1, 101),
            {
              icon: notificationIconMap.Enrich,
            }
          );
          return baseQueryClient.invalidateQueries([
            useBrowseEnrichmentApi.name,
          ]);
        })
        .catch(() => {
          loading.onFalse();
        })
        .finally(loading.onFalse);
    };

    return (
      <CreateActionBulkDialog
        state={state}
        id={item.id}
        title="Edit Enrichment Name"
        icon="edit-outline"
        inputTitle="Enrichment Name:"
        isEdit
        hasVisibility={false}
        defaultValue={item.name}
        loading={api.isLoading}
        onClick={handleSubmit}
      />
    );
  }
);

EditEnrichmentDialog.displayName = 'EditEnrichmentDialog';
